export type CollapsiblePanelCss = {
  collapsiblePanel: string;
  collapsiblePanelButton: string;
  collapsiblePanelButtonIcon: string;
};

export type CollapsiblePanelCssOptions = {
  className?: string;
  overrideCss?: boolean;
  isCollapsed?: boolean;
};

export const collapsiblePanelCss = ({
  className,
  isCollapsed,
  overrideCss,
}: CollapsiblePanelCssOptions = {}): CollapsiblePanelCss => {
  const collapsiblePanel: string[] = [];
  const collapsiblePanelButton: string[] = [];
  const collapsiblePanelButtonIcon: string[] = [];

  if (!overrideCss) {
    collapsiblePanel.push('collapsible-panel');
    collapsiblePanelButton.push('collapsible-panel__collapse-button');
    collapsiblePanelButtonIcon.push('collapsible-panel__button-icon');

    if (isCollapsed) {
      collapsiblePanel.push('collapsible-panel--collapsed');
      collapsiblePanelButton.push(
        'collapsible-panel__collapse-button--collapsed'
      );
    }
  }

  if (className) {
    collapsiblePanel.push(`${className}`);
    collapsiblePanelButton.push(`${className}__collapse-button`);
    collapsiblePanelButtonIcon.push(`${className}__button-icon`);

    if (isCollapsed) {
      collapsiblePanel.push(`${className}--collapsed`);
      collapsiblePanelButton.push(`${className}__collapse-button--collapsed`);
    }
  }

  return {
    collapsiblePanel: collapsiblePanel.join(' '),
    collapsiblePanelButton: collapsiblePanelButton.join(' '),
    collapsiblePanelButtonIcon: collapsiblePanelButtonIcon.join(' '),
  };
};
